import { RowsWithRefs } from "PFApp/booking/store";
import { Row } from "PFApp/booking/types";

import { findClosestProfileRow } from "./find_closest_profile_row";

type CalculateDropZoneHeight = {
  targetRow: Row;
  rows: Row[];
  rowsByKey: Record<string, Row>;
  rowsWithRefs: RowsWithRefs<Row>;
};

export const calculateDropZoneHeight = ({
  targetRow,
  rows,
  rowsByKey,
  rowsWithRefs
}: CalculateDropZoneHeight): number => {
  const closestProfileRow = findClosestProfileRow({ row: targetRow, rowsByKey });
  if (!closestProfileRow) {
    return 0;
  }

  const lastRelatedRow = [...rows]
    .reverse()
    .find((row) => row.key === closestProfileRow.key || row.parents.includes(closestProfileRow.key));

  if (!lastRelatedRow) {
    return 0;
  }

  const profileRowRef = rowsWithRefs.get(closestProfileRow.key)?.rowRef;
  const lastRelatedRowRef = rowsWithRefs.get(lastRelatedRow.key)?.rowRef;

  if (!profileRowRef || !lastRelatedRowRef) {
    return 0;
  }

  return lastRelatedRowRef.getBoundingClientRect().bottom - profileRowRef.getBoundingClientRect().top;
};
